import { getPopUpData } from '../../../pages/productPageInjector/utils';
import { getAppProps, getPriceNumberFormatDefault } from '../../../utils';
import { upsellInputPrefix } from './data';
import {
  getItemDescriptionById,
  getItemDiscountById
} from '../../../utils/item';
import { sold } from '../../../templates';
import { isPopupsLoaded, isShowMainProduct } from './common';
import { TRANSLATE_IDS, translateText } from '../../../utils/translate';

const styles = {
  verticalSoldOut: 'margin: 10px auto 0;',
  defaultSoldOut: 'margin: 0;'
};

const parseItem = v => {
  let price = v.price;
  let originalPrice = v.compare_at_price;
  const discount = v.discount;

  if (typeof discount === 'number' && discount > 0) {
    price = price - (price / 100) * discount;
  }

  let save = originalPrice - price;

  price = getPriceNumberFormatDefault(price);
  originalPrice = getPriceNumberFormatDefault(originalPrice);

  let img = '';

  if (v.featured_image && typeof v.featured_image.src === 'string') {
    img = v.featured_image.src;
  }

  if (save > 0) {
    save = getPriceNumberFormatDefault(save);
  } else {
    save = null;
  }

  return {
    ...v,
    price,
    originalPrice,
    img,
    save
  };
};

function getActualAddons() {
  return window.upsell.popups;
}

function renderHead(options) {
  const title = options.showPopUpHeaderText
    ? options.popUpHeaderText
    : 'Hang on!';
  const desc = options.showPopUpDescText
    ? options.popUpDescText
    : 'We have a special offer for you:';

  const showDesc = desc !== '';

  return `
    <span id="un-modal-close-btn" onclick="window.upsellClosePopUp()">x</span>
    <div id="un-modal-title">${title}</div>
    ${showDesc ? `<div id="un-modal-description">${desc}</div>` : ''}
  `;
}

function renderMainProduct(data) {
  let originalPriceVisible = true;
  if (data.price === data.originalPrice) {
    originalPriceVisible = false;
  }
  return `
      <li class="upsell-product-list-item purchased-product">
        <div class="upsell-product-image-container">
          <span class="checkmark">
            <div class="checkmark_circle"></div>
            <div class="checkmark_stem"></div>
            <div class="checkmark_kick"></div>
          </span>
          <div class="upsell-product-image-wrap">
            <img src="${data.img}" class="upsell-product-image popup-cursor">
          </div>
        </div>
        <div class="upsell-product-info">
          <span class="upsell-product-title">${data.title}</span>
          <div class="upsell-product-prices">
            <span class="upsell-product-price">${data.price}</span>
            ${
              originalPriceVisible
                ? `
                <span class="upsell-product-original-price">${data.originalPrice}</span>`
                : ''
            }
          </div>
        </div>
      </li>
  `;
}

function renderSave(save, isVertical) {
  if (!save) {
    return '';
  }

  const classes =
    'upsell-product-savings ' +
    (isVertical ? 'upsell-product-savings-vertical' : '');

  const saveText = translateText(TRANSLATE_IDS.popUpSaveText);

  return `
    <span class="${classes}">${saveText} ${save}</span>
  `;
}

function renderQty(popUpType, data) {
  let visible = false;

  if (popUpType === 'button') {
    visible = false;
  } else if (popUpType === 'buttonQtyBox') {
    visible = true;
  } else if (popUpType === 'checkbox') {
    visible = false;
  } else if (popUpType === 'checkboxQtyBox') {
    visible = true;
  }

  if (!visible) return '';

  return `
    <input 
        id="${upsellInputPrefix}${data.id}"
        type="number"
        name="quantity"
        value="1"
        required=""
        min="1"
        max="999"
        class="upsell-now-quantity-field"
        pattern="[0-9]*"
    >
  `;
}

function renderButton(popUpType, data, vertical) {
  let onclick = null;

  if (popUpType === 'button') {
    onclick = `window.upsellAddPopUpToggleItem(${data.id}, null)`;
  } else if (popUpType === 'buttonQtyBox') {
    onclick = `window.upsellAddPopUpToggleItem(${data.id}, {input: true})`;
  } else if (popUpType === 'checkbox') {
    onclick = `window.upsellAddPopUpToggleItem(${data.id}, null)`;
  } else if (popUpType === 'checkboxQtyBox') {
    onclick = `window.upsellAddPopUpToggleItem(${data.id}, {input: true})`;
  }

  if (vertical && popUpType === 'checkbox') {
    return `
      <input
        type="checkbox"
        onclick="${onclick}"
        class="uppsell-product-checkbox-left-vertical"
      >
    `;
  }

  if (popUpType === 'checkbox' || popUpType === 'checkboxQtyBox') {
    return `
      <input
        type="checkbox"
        onclick="${onclick}"
        class="upsell-product-add-to-cart-checkbox"
      >
    `;
  }

  const addText = translateText(TRANSLATE_IDS.popUpAddItemText);

  return `
    <button 
        class="upsell-product-add-to-cart upsell-button" 
        onclick="${onclick}"
    >
        <svg viewBox="0 0 100 100">
            <path d="M25.6 44.4h18.8V25.6c0-7.5 11.2-7.5 11.2 0v18.8h18.8c7.5 0 7.5 11.2 0 11.2H55.6v18.8c0 7.5-11.2 7.5-11.2 0V55.6H25.6c-7.5 0-7.5-11.2 0-11.2z" fill="currentColor" fill-rule="nonzero"></path>
        </svg>
        <span>${addText}</span>
    </button>
  `;
}

function renderImageContainer(args) {
  const { showLeftCheckbox, popUpType, data, isVertical, showSold } = args;

  let showBtn = true;
  if (showSold) {
    showBtn = false;
  }
  if (!showLeftCheckbox) {
    showBtn = false;
  }

  return `
    <div class="upsell-product-image-container">
        ${showBtn ? renderButton(popUpType, data, isVertical) : ''}
        <div class="upsell-product-image-wrap">
            <span class="checkmark" style="display:none;">
              <div class="checkmark_circle"></div>
              <div class="checkmark_stem"></div>
              <div class="checkmark_kick"></div>
            </span>
            <img src="${data.img}" class="upsell-product-image">
        </div>
    </div>
  `;
}

function renderCartFields(args) {
  const { showLeftCheckbox, popUpType, data, isVertical, showSold } = args;

  let showInputBlock = true;

  if (showSold) {
    showInputBlock = false;
  }

  if (showLeftCheckbox) {
    showInputBlock = false;
  }

  const classWrap = isVertical
    ? 'upsell-product-cart-fields-vertical'
    : 'upsell-product-cart-fields';

  return `
    <div class="${classWrap}">
          ${!showSold ? renderQty(popUpType, data) : ''}
          ${showInputBlock ? renderButton(popUpType, data, isVertical) : ''}
    </div>
  `;
}

function renderTitle(data, options, isVertical) {
  const classesTitle =
    'upsell-product-title upsell-product-title-max ' +
    (isVertical ? '' : 'upsell-product-title-horizontal');

  const style = `
    text-decoration: inherit;
    color: inherit;
  `;

  const titleElement = options.popUpLinkTitle
    ? `<a style="${style}" href="${data.url}"   ${
        options.linkInNewPage ? 'target="_blank"' : ''
      }>${data.title}</a>`
    : data.title;

  const seeDetails = options.showPopUpDetailsLink;
  const detailsText = options.seeDetailsText || '(See details)';

  const seeDetailsElement = seeDetails
    ? `
    <a style="${style}" href="${data.url}" target="_blank">
        ${detailsText}
    </a>
  `
    : '';

  return `
    <div class="${classesTitle}">${titleElement}</div>
    ${seeDetailsElement}
  `;
}

function renderRow(data, options) {
  const isVertical = options.popUpBoxType === 'ImgTop';
  const classes =
    'upsell-product-list-item ' +
    (isVertical
      ? 'upsell-product-list-item-vertical'
      : 'upsell-product-list-item-horizontal');

  const classesOriginalPrice =
    'upsell-product-original-price ' +
    (isVertical ? 'upsell-product-original-price-vertical' : '');

  const classesProductPrices =
    'upsell-product-prices ' +
    (isVertical ? 'upsell-product-prices-vertical' : '');

  const classesDesc = isVertical
    ? 'upsell-product-desc-vertical'
    : 'upsell-product-desc-horizontal';

  const popUpType = options.popUpAddOnType;

  const showLeftCheckbox = isVertical && popUpType === 'checkbox';

  let originalPriceVisible = true;
  if (data.price === data.originalPrice) {
    originalPriceVisible = false;
  }

  let showSold = false;
  if (data.quantity === 0) {
    showSold = true;
  }

  let soldStyle = styles.defaultSoldOut;
  if (isVertical) {
    soldStyle = styles.verticalSoldOut;
  }

  const description = data.description;

  const descBlock = `
        <div class="${classesDesc}">
            ${description}
        </div>
  `;

  const titleElement = renderTitle(data, options, isVertical);

  return `
    <li class="${classes}" id="upsell-product-${data.id}">
        ${renderImageContainer({
          showLeftCheckbox,
          popUpType,
          data,
          isVertical,
          showSold
        })}
        <div class="upsell-product-info">
          ${titleElement}
          <div class="${classesProductPrices}">
            <span class="upsell-product-price">${data.price}</span>
            ${
              originalPriceVisible
                ? `
                <span class="${classesOriginalPrice}">${data.originalPrice}</span>`
                : ''
            }
            ${renderSave(data.save, isVertical)}
          </div>
          ${showSold ? sold(soldStyle) : ''}
           ${!isVertical ? descBlock : ''}
        </div>
        ${renderCartFields({
          showLeftCheckbox,
          popUpType,
          data,
          isVertical,
          showSold
        })}
        ${isVertical ? descBlock : ''}
      </li>
  `;
}

function renderBottom(_, options) {
  const addOnType = options.popUpAddOnType;

  let showNoImGood = false;
  let cartText = translateText(TRANSLATE_IDS.popUpContinueShoppingText);

  if (addOnType === 'checkbox' || addOnType === 'checkboxQtyBox') {
    cartText = translateText(TRANSLATE_IDS.popUpAddToCartText);
    showNoImGood = true;
  }

  const textNoIamGood = translateText(TRANSLATE_IDS.popUpNoIamGoodText);

  return `
    <div class="upsell-footer-buttons">
      ${
        showNoImGood
          ? `<a 
        href="#"
        onclick='window.upsellAddPopUpMainProduct()' 
        class="upsell-now-no-thanks" 
        id="upsell-popup-close-link"
      >
        ${textNoIamGood}
      </a>`
          : ''
      }
      <button 
        class="upsell-button upsell-now-continue" 
        id="upsell-popup-continue-button"
        onclick="window.upsellAddPopUpSelectProducts()"
      >
        ${cartText}
      </button>
    </div>
  `;
}

function renderRows(rows, options) {
  const isVertical = options.popUpBoxType === 'ImgTop';
  const showMax2Variants = isVertical && rows.length <= 2;
  const rowsStr = rows.join('');

  if (!showMax2Variants) {
    return rowsStr;
  }

  return `
    <div class='upsell-product-container-wrapper-vertical'>
        ${rowsStr}
    </div>
  `;
}

function renderLoader() {
  return `
    <div class="upsell-popup-loader">
    </div>
  `;
}

function addItem({ v, popups, rows, options }) {
  let compareAtPrice = v.compareAtPrice;

  if (!compareAtPrice || compareAtPrice === '') {
    compareAtPrice = v.price;
  }

  const item = parseItem({
    id: v.id,
    title: v.title,
    price: parseFloat(v.price),
    compare_at_price: parseFloat(compareAtPrice),
    featured_image: { src: v.image },
    discount: getItemDiscountById(popups, {
      variant_id: v.id
    }),
    description: getItemDescriptionById(popups, {
      variant_id: v.id
    }),
    url: v.url
  });
  item.quantity = v.quantity;

  rows.push(renderRow(item, options));
}

export function render() {
  const { options, popups } = getAppProps();
  const { product: data } = getPopUpData();
  const addOns = getActualAddons();

  let compareAtPrice = data.compare_at_price;
  if (!compareAtPrice || compareAtPrice === '') {
    compareAtPrice = data.price;
  }

  const item = parseItem({
    ...data,
    price: parseFloat(data.price) / 100,
    compare_at_price: parseFloat(compareAtPrice) / 100,
    discount: 0
  });

  const product = {
    ...item,
    img: data.featured_image
  };

  const rows = [];

  addOns.forEach(v => {
    const variantOptions = v.variantOptions;
    if (variantOptions) {
      variantOptions.forEach(v => {
        addItem({ v, popups, rows, options });
      });
    } else {
      addItem({ v, popups, rows, options });
    }
  });

  const showMainProduct = isShowMainProduct();
  const showLoader = !isPopupsLoaded();

  let html = `
    <div id="un-modal-background" class="un-manual-modal-container">
      <div id="un-modal-content">
        ${renderHead(options)}
        <ul id="upsell-product-table">
          ${showMainProduct ? renderMainProduct(product) : ''}
          ${showLoader ? renderLoader() : renderRows(rows, options)}
        </ul>
        ${renderBottom(product, options)}
      </div>
    </div>
  `;

  return html;
}
